import axiosInstance from "../../axios";
import urls from "../../Utils/urls";
import { SMS_CONSENT_VERSION, SMS_OPT_IN_TEXT } from "../../pages/Profile/smsConsent";

const API_V1 = urls.admin.getAuthToken.replace(/\/auth\/get_auth_token$/, "");

// Session-protected MFA settings calls. The shared interceptor supplies the JWT.
export const getStatus = async () => (await axiosInstance.get(`${API_V1}/mfa/status`)).data;

export const startStepUp = async ({ method }) =>
  (await axiosInstance.post(`${API_V1}/mfa/step-up/start`, { method })).data;

export const verifyStepUp = async ({ stepUpTx, code }) =>
  (await axiosInstance.post(`${API_V1}/mfa/step-up/verify`, { step_up_tx: stepUpTx, code })).data;

export const enrollAuthenticator = async ({ stepUpToken }) =>
  (await axiosInstance.post(`${API_V1}/mfa/authenticator/enroll`, { step_up_token: stepUpToken })).data;

export const confirmAuthenticator = async ({ enrollmentId, code }) =>
  (await axiosInstance.post(`${API_V1}/mfa/authenticator/confirm`, { enrollment_id: enrollmentId, code })).data;

export const disableAuthenticator = async ({ stepUpToken }) =>
  (await axiosInstance.post(`${API_V1}/mfa/authenticator/disable`, { step_up_token: stepUpToken })).data;

// docs/specs/authenticator-mfa-sms-enroll.md: the mobile asked for after an authenticator is set up. On the login
// path the session is not stored yet, so its token is passed in and sent as the jwt header the interceptor would add.
export const saveSmsAlerts = async ({ mobile, token }) =>
  (await axiosInstance.post(
    `${API_V1}/mfa/sms-alerts`,
    { mobile, consent_text: SMS_OPT_IN_TEXT, consent_version: SMS_CONSENT_VERSION },
    ...(token ? [{ headers: { jwt: token } }] : []),
  )).data;

// docs/specs/login-setup.md §4: the sign-in method order. Node takes the user from the JWT only; no step-up.
export const getPrefs = async () => (await axiosInstance.get(`${API_V1}/mfa/prefs`)).data;

export const savePrefs = async ({ priority }) => (await axiosInstance.post(`${API_V1}/mfa/prefs`, { priority })).data;
